import { render, staticRenderFns } from "./ADRClassForm.vue?vue&type=template&id=12062fe4"
import script from "./ADRClassForm.vue?vue&type=script&lang=js"
export * from "./ADRClassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports